<div class="fixed bottom-5 right-5 z-1000 flex flex-col items-end">
  
  <button (click)="toggleChat()" 
          class="w-16 h-16 bg-gradient-to-b from-slate-800 to-slate-900 rounded-full p-1 shadow-2xl transition-transform hover:scale-110 active:scale-95 flex items-center justify-center border-2 border-cyan-400/50">
    <img src="assets/images/bot.png" alt="Bot" class="w-full h-full object-contain animate-pulse">
  </button>

  <div *ngIf="isOpen()" 
       class="w-[350px] sm:w-[400px] h-[500px] bg-slate-900 rounded-2xl shadow-2xl border border-slate-700/50 flex flex-col overflow-hidden mb-4 transition-all duration-300">
    
    <div class="bg-gradient-to-r from-purple-900 to-indigo-900 p-4 flex items-center justify-between border-b border-purple-500/30">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-slate-800 rounded-full p-0.5 border border-cyan-400">
          <img src="assets/images/bot.png" alt="Bot Avatar" class="w-full h-full object-contain">
        </div>
        <div>
          <h3 class="text-white font-bold text-sm tracking-wide">Gbot - Tu Asistente Virtual</h3>
          <span class="text-xs text-cyan-400 flex items-center gap-1">
            <span class="w-2 h-2 bg-green-500 rounded-full inline-block animate-ping"></span> En línea
          </span>
        </div>
      </div>
      <button (click)="toggleChat()" class="text-slate-400 hover:text-white transition-colors">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>

    <div class="flex-1 p-4 overflow-y-auto space-y-4 bg-gradient-to-b from-slate-950 to-slate-900">
      <div *ngFor="let msg of messages()" 
           [ngClass]="msg.isBot ? 'justify-start' : 'justify-end'" class="flex items-end gap-2">
        
        <div *ngIf="msg.isBot" class="w-7 h-7 bg-slate-800 rounded-full p-0.5 border border-cyan-500/50 flex-shrink-0">
          <img src="assets/images/bot.png" class="w-full h-full object-contain">
        </div>

        <div [ngClass]="msg.isBot ? 'bg-slate-800 text-slate-100 border border-slate-700/50 rounded-br-2xl rounded-tr-2xl rounded-tl-2xl' : 'bg-blue-600 text-white rounded-bl-2xl rounded-tr-2xl rounded-tl-2xl'"
             class="max-w-[75%] p-3 text-sm shadow-md">
          <p class="leading-relaxed whitespace-pre-line">{{ msg.text }}</p>
          <span class="text-[10px] block text-right mt-1 opacity-60">{{ msg.timestamp | date:'shortTime' }}</span>
        </div>
      </div>

      <div *ngIf="isLoading()" class="flex items-center gap-2 justify-start">
        <div class="w-7 h-7 bg-slate-800 rounded-full p-0.5 border border-cyan-500/50">
          <img src="assets/images/bot.png" class="w-full h-full object-contain animate-bounce">
        </div>
        <div class="bg-slate-800 p-3 rounded-2xl flex gap-1">
          <div class="w-2 h-2 bg-cyan-400 rounded-full animate-bounce" style="animation-delay: 0ms"></div>
          <div class="w-2 h-2 bg-cyan-400 rounded-full animate-bounce" style="animation-delay: 150ms"></div>
          <div class="w-2 h-2 bg-cyan-400 rounded-full animate-bounce" style="animation-delay: 300ms"></div>
        </div>
      </div>
    </div>

    <div class="p-3 bg-slate-950 border-t border-slate-800 flex items-center gap-2">
      <input [(ngModel)]="userInput" 
             (keyup.enter)="send()"
             type="text" 
             placeholder="Escribe un mensaje..." 
             class="flex-1 bg-slate-900 border border-slate-700 rounded-xl px-4 py-2 text-sm text-white focus:outline-none focus:border-cyan-500 placeholder-slate-500" />
      <button (click)="send()" 
              [disabled]="!userInput().trim() || isLoading()"
              class="bg-blue-600 hover:bg-blue-500 disabled:opacity-40 disabled:hover:bg-blue-600 p-2.5 rounded-xl text-white transition-colors shadow-lg shadow-blue-900/30">
        <svg class="w-5 h-5 transform rotate-90" fill="currentColor" viewBox="0 0 20 20"><path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path></svg>
      </button>
    </div>
  </div>
</div>